import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select, message, InputNumber } from "antd";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import _ from "lodash";
import barrierService from "../../../../../../services/BarrierService";
import { barrierThunks } from "../../../_redux/thunk";
import { filterOption } from "core/helpers";
import { PAGINATION } from "../../../_redux/constant";

function AddEditGate({ modal, onShowModal }) {
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  let { visible, isEdit, stations, id, data } = modal;

  const dispatch = useDispatch();
  const [param, setParam] = useState({
    page: PAGINATION.camera.page,
    size: PAGINATION.camera.size,
  });

  const [buttonLoading, setButtonLoading] = useState({
    value: false,
  });

  const [form] = Form.useForm();

  let title = "Tạo mới thông tin cổng barrier";
  if (isEdit) {
    title = "Chỉnh sửa thông tin cổng barrier";
  }

  const _callApi = async (id, data, isStationChanged, isEdit) => {
    setButtonLoading((prev) => ({
      ...prev,
      value: true,
    }));

    let response = null;
    if (isEdit) {
      response = await barrierService.updateGate(id, data);
    } else {
      response = await barrierService.createGate(data);
    }
    setButtonLoading((prev) => ({
      ...prev,
      value: false,
    }));
    if (response && response.data && response.data.success) {
      await dispatch(barrierThunks.getGatesThunk(param));
      if (isStationChanged)
        await dispatch(barrierThunks.getLogFilterDataThunk());
      message.success(`${title} thành công.`);
      onShowModal();
    } else {
      message.error(get(response, "data.message", "Có lỗi xảy ra."), 5);
    }
  };

  const _handleSubmit = async () => {
    try {
      let validate = await form.validateFields();
      if (!validate.outOfDate) {
        const { station_id, gate_id, gate_name } = form.getFieldsValue([
          "station_id",
          "gate_id",
          "gate_name",
        ]);
        const data = {
          station_id: station_id.value,
          station_name: station_id.label,
          gate_id,
          gate_name,
        };

        let isStationChanged = false;
        if (isEdit) {
          if (data?.station_id?.toString() != station_id.value)
            isStationChanged = true;
        } else {
          isStationChanged = true;
        }
        _callApi(id, data, isStationChanged, isEdit);
        _handleReset();
      }
    } catch (error) {}
  };

  const _handleReset = () => {
    form.resetFields();
  };

  const _handleCancel = () => {
    form.resetFields();
    onShowModal();
  };

  useEffect(() => {
    if (isEdit === true && visible) {
      form.setFieldsValue({
        gate_id: data.gate_id,
        gate_name: data.gate_name,
        station_id: _.find(stations, (x) => x.value == data.station_id),
      });
    } else {
      form.setFieldsValue({
        gate_name: "",
        station_id: undefined,
      });
    }
  }, [isEdit, visible, form, data, stations]);

  return (
    <Modal
      destroyOnClose={true}
      width={600}
      onCancel={() => {
        _handleCancel();
      }}
      title={title}
      open={visible}
      footer={[
        <Button key="back" onClick={_handleReset} type="dashed" danger>
          Làm mới
        </Button>,
        <Button
          key="submit"
          onClick={_handleSubmit}
          loading={buttonLoading.value}
          type="primary"
        >
          Lưu
        </Button>,
      ]}
    >
      <Form
        {...layout}
        autoComplete="off"
        layout="horizontal"
        form={form}
        onFinish={_handleSubmit}
        // initialValues={{
        //   ["station_id"]: data?.station_id,
        //   ["gate_name"]: data?.gate_name,
        //   ["gate_id"]: data?.gate_id,
        // }}
        labelAlign={"left"}
      >
        <Form.Item
          required
          label="Kho"
          labelAlign="left"
          name="station_id"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn kho",
            },
          ]}
        >
          <Select
            filterOption={(inputValue, option) =>
              filterOption(inputValue, option.label)
            }
            placeholder="Chọn kho"
            allowClear
            labelInValue
            showSearch
            options={stations}
          />
        </Form.Item>

        {isEdit && (
          <Form.Item
            label={"ID Cổng"}
            rules={[
              {
                required: true,
                message: "Vui lòng nhập ID cổng",
              },
            ]}
            name={"gate_id"}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={1}
              disabled={true}
              placeholder="Nhập ID cổng"
              allowClear
            />
          </Form.Item>
        )}

        <Form.Item
          label={"Tên Cổng"}
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên cổng",
            },
          ]}
          name={"gate_name"}
        >
          <Input allowClear placeholder="Nhập cổng" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddEditGate;
